/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Children_TitleInputs */

const es_privacy_policy_children_title = /** @type {(inputs: Privacy_Policy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Privacidad de los Menores`)
};

const en_privacy_policy_children_title = /** @type {(inputs: Privacy_Policy_Children_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Children's Privacy`)
};

/**
* | output |
* | --- |
* | "9. Children's Privacy" |
*
* @param {Privacy_Policy_Children_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_children_title = /** @type {((inputs?: Privacy_Policy_Children_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Children_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_children_title(inputs)
	return en_privacy_policy_children_title(inputs)
});
export { privacy_policy_children_title as "privacy_policy.children.title" }